/* ==========================================================================
   SANS PEUR — Global JS
   ========================================================================== */

(function () {
  'use strict';

  /* --------------------------------------------------------------------------
     Mobile Menu Toggle
     -------------------------------------------------------------------------- */
  const hamburgerBtn = document.getElementById('MobileMenuOpen');
  const closeBtn = document.getElementById('MobileMenuClose');
  const overlay = document.getElementById('MobileMenuOverlay');

  function openMobileMenu() {
    if (!overlay) return;
    overlay.classList.add('is-active');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  function closeMobileMenu() {
    if (!overlay) return;
    overlay.classList.remove('is-active');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (hamburgerBtn) hamburgerBtn.focus();
  }

  if (hamburgerBtn) {
    hamburgerBtn.addEventListener('click', openMobileMenu);
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', closeMobileMenu);
  }

  // Close on overlay backdrop click
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeMobileMenu();
    });
  }

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (overlay?.classList.contains('is-active')) closeMobileMenu();
    }
  });

  /* --------------------------------------------------------------------------
     Cart Count Update
     -------------------------------------------------------------------------- */
  function updateCartCount(count) {
    const countBubbles = document.querySelectorAll('.cart-count-bubble');
    countBubbles.forEach((el) => {
      el.textContent = count > 0 ? count : '';
      el.dataset.count = count;
    });
  }

  async function fetchCartCount() {
    try {
      const response = await fetch('/cart.js', {
        headers: { 'Content-Type': 'application/json' },
      });
      const cart = await response.json();
      updateCartCount(cart.item_count);
    } catch (err) {
      console.error('Error fetching cart:', err);
    }
  }

  // Fetch initial cart count
  fetchCartCount();

  /* --------------------------------------------------------------------------
     Cart Notification
     -------------------------------------------------------------------------- */
  const cartNotification = document.getElementById('CartNotification');
  const cartNotificationClose = document.getElementById('CartNotificationClose');
  let notificationTimeout;

  window.showCartNotification = function (message = 'Item added to cart') {
    if (!cartNotification) return;
    const textEl = cartNotification.querySelector('.cart-notification__text');
    if (textEl) textEl.textContent = message;

    cartNotification.classList.add('is-visible');
    clearTimeout(notificationTimeout);
    notificationTimeout = setTimeout(() => {
      cartNotification.classList.remove('is-visible');
    }, 3500);
  };

  if (cartNotificationClose) {
    cartNotificationClose.addEventListener('click', () => {
      cartNotification.classList.remove('is-visible');
      clearTimeout(notificationTimeout);
    });
  }

  /* --------------------------------------------------------------------------
     Add to Cart via AJAX (global handler)
     Called by product.js and product-card quick-add
     -------------------------------------------------------------------------- */
  window.addToCart = async function (formData) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || 'Could not add to cart');
      }

      const item = await response.json();
      await fetchCartCount();
      window.showCartNotification(`${item.title} added to cart`);
      return item;
    } catch (err) {
      console.error('Add to cart error:', err);
      alert(err.message || 'Error adding to cart');
      throw err;
    }
  };

  /* --------------------------------------------------------------------------
     Quick Add — product card buttons
     -------------------------------------------------------------------------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;

    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.textContent = '...';
    btn.disabled = true;

    try {
      await window.addToCart({ id: variantId, quantity: 1 });
      btn.textContent = 'ADDED';
      setTimeout(() => {
        btn.textContent = 'QUICK ADD';
        btn.disabled = false;
      }, 2000);
    } catch {
      btn.textContent = 'QUICK ADD';
      btn.disabled = false;
    }
  });

  /* --------------------------------------------------------------------------
     Smooth scroll for anchor links
     -------------------------------------------------------------------------- */
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* --------------------------------------------------------------------------
     Newsletter form
     -------------------------------------------------------------------------- */
  const newsletterForms = document.querySelectorAll('.newsletter-form');
  newsletterForms.forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const emailInput = form.querySelector('input[type="email"]');
      if (!emailInput) return;

      const submitBtn = form.querySelector('.newsletter-submit');
      if (submitBtn) {
        submitBtn.textContent = 'SUBSCRIBED';
        submitBtn.disabled = true;
      }

      // Shopify handles newsletter via form action — just reset UI
      setTimeout(() => {
        if (submitBtn) {
          submitBtn.textContent = 'SUBSCRIBE';
          submitBtn.disabled = false;
        }
        emailInput.value = '';
      }, 3000);
    });
  });

  /* --------------------------------------------------------------------------
     Search Overlay
     -------------------------------------------------------------------------- */
  const searchOpen = document.getElementById('SearchOpen');
  const searchClose = document.getElementById('SearchClose');
  const searchOverlay = document.getElementById('SearchOverlay');
  const searchInput = document.getElementById('SearchInput');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-active');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (searchOpen) searchOpen.setAttribute('aria-expanded', 'true');
    setTimeout(() => { if (searchInput) searchInput.focus(); }, 100);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-active');
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (searchOpen) searchOpen.setAttribute('aria-expanded', 'false');
  }

  if (searchOpen) searchOpen.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  if (searchOverlay) {
    searchOverlay.addEventListener('click', function (e) {
      if (e.target === searchOverlay) closeSearch();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearch();
  });

})();
